

export default () => {
  var slidesVariation = 56;
  var slideChangeDelay = 300;
  var maxMobileSize = 768;
  var windowWidth = window.innerWidth;
  var isMobile;

  //Olw carousel initialization:
  var vg_slider = $('.vignette-slider .vg-slider').owlCarousel({
    autoHeight: true,
    dots: false,
    responsive:{
      0: {
        items: 2
      },
      768: {
        items: 3
      }
    }
  });

  // Comprobamos que existe el objeto para no ejecutar el resto del código cuando no sea necesario
  if (!vg_slider.length) {
    return;
  }

  //isMobile initialization:
  if(windowWidth < maxMobileSize){
    isMobile = true;
    owlInit();
  }else{
    isMobile = false;
  }


  /* EVENTS: */

  //Window resize event:
  $(window).resize(function(){
    windowWidth = window.innerWidth;

    if(windowWidth < maxMobileSize && !isMobile){
      isMobile = true;
      owlInit();
    }else if(windowWidth >= maxMobileSize && isMobile){
      isMobile = false;
    }
  });

  //Carousel arrow click event:
  $('.vignette-slider .nav-control').off('click').click(function() {

    if(isMobile){

      if($(this).hasClass('right')){
        if(!$(this).hasClass('disabled')){
          vg_slider.trigger('next.owl.carousel', [slideChangeDelay]);
          addSlideVariation(slidesVariation);
        }else if(!$(this).hasClass('lastVariation')){
          $(this).addClass('lastVariation');
          addSlideVariation(-slidesVariation*2);
        }

      }else if($(this).hasClass('left') && !$(this).hasClass('disabled')){
        vg_slider.trigger('prev.owl.carousel', [slideChangeDelay]);
        addSlideVariation(slidesVariation);
      }

    }else{
      if($(this).hasClass('right')){
        vg_slider.trigger('next.owl.carousel', [slideChangeDelay]);
      }else if($(this).hasClass('left')){
        vg_slider.trigger('prev.owl.carousel', [slideChangeDelay]);
      }
    }

    checkDisabledArrow();
  });

  //Carousel on drag event:
  vg_slider.on('dragged.owl.carousel', function (){
    if(isMobile){
      addSlideVariation(slidesVariation);
    }
    checkDisabledArrow();
  });


  /* FUNCTIONS: */

  function owlInit(){
    addSlideVariation(slidesVariation);
    checkDisabledArrow();
  }

  function addSlideVariation(slidesVariation){
    var olwStage = vg_slider.find('.owl-stage');
    var styleAttr = olwStage.attr('style');
    var owlStageStyle = styleAttr.split('px');
    var transformPart = owlStageStyle[0].split('(');
    var transformNewValue;

    transformNewValue = parseInt(transformPart[1])+slidesVariation;

    var newOwlStageStyle = "transform: translate3d("+transformNewValue+"px, 0px, 0px"+owlStageStyle[3]+"px;";
    olwStage.attr("style", newOwlStageStyle);
  }

  function checkDisabledArrow(){

    if($('.vg-slider').find('.owl-item:first-child').hasClass('active')){
      $('.vignette-slider .nav-control.left').addClass('disabled');
    }else if($('.vignette-slider .nav-control.left').hasClass('disabled')){
      $('.vignette-slider .nav-control.left').removeClass('disabled');
    }

    if($('.vg-slider').find('.owl-item:last-child').hasClass('active')){
      $('.vignette-slider .nav-control.right').addClass('disabled');
    }else if($('.vignette-slider .nav-control.right').hasClass('disabled')){
      $('.vignette-slider .nav-control.right').removeClass('disabled lastVariation');
    }
  }
}
